import { formatTime, type NextSessionResult } from "@mixitone/util";

export function ymd(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatCompactSessionTime(localTime: string, locale?: string | string[]) {
  if (!localTime) return "";
  return formatTime(localTime, locale);
}

export function formatNextSessionHeading(
  nextSession: NextSessionResult,
  locale: string | string[] = "en-NZ",
  now = new Date(),
): string {
  const todayYmd = ymd(now);
  const timePart = formatCompactSessionTime(nextSession.localTime, locale);
  if (nextSession.localDate === todayYmd) {
    return timePart ? `Today at ${timePart}` : "Today";
  }
  const [year, month, day] = nextSession.localDate.split("-").map(Number);
  const utc = new Date(Date.UTC(year, month - 1, day));
  const datePart = new Intl.DateTimeFormat(locale, {
    weekday: "short",
    day: "numeric",
    month: "short",
  }).format(utc);
  return timePart ? `${datePart} at ${timePart}` : datePart;
}
